import { ModalHeader } from "components/templates/Modals/ModalHeader";
import { ModalPadding } from "components/templates/Modals/ModalPadding";
import { PaziaModal } from "components/molecules";
import { ResourceTabForm, ResourceTabFormValues } from "./ResourceTabForm";

interface AddCourseResourceTabModalProps {
  onCloseRequest: () => void;
  isOpen: boolean;
  onSubmit: (data: ResourceTabFormValues) => Promise<void>;
}

export const AddCourseResourceTabModal = ({ onCloseRequest, isOpen, onSubmit }: AddCourseResourceTabModalProps) => {
  return (
    <PaziaModal
      id="add-resource-tab-modal"
      onCloseRequest={() => {
        onCloseRequest();
      }}
      isOpen={isOpen}
      size="lg"
    >
      {isOpen && (
        <ModalPadding>
          <ModalHeader>Dodaj nową zakładkę</ModalHeader>
          <ResourceTabForm onSubmit={onSubmit} />
        </ModalPadding>
      )}
    </PaziaModal>
  );
};
